export default "__VITE_ASSET__BeYDD3wj__"